import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import { SchemaClientKinds, Source } from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";


export type Tag = {
  filterValue: string;
};

const listTags: Source<Tag[]> = {
  graphql: parse(`
    query instrumentFilterValues($nextToken: String) {
      instrumentFilterValues(
        filterAttribute: "tags",
        nextToken: $nextToken
      ) {
        nextToken
        items {
          filterValue
        }
      }
    }
  `),
};

export const getTags = async (client: SchemaClient): Promise<Tag[] | typeof EMPTY_VALUE> => {
  if (client.kind !== SchemaClientKinds.GRAPHQL) {
    return [];
  }
  return await client.queryList(listTags);
};

export const getAndProcessTags = async (client: SchemaClient): Promise<Tag[]> => {
  const tags = await getTags(client);
  return tags?.map((tag) => ({
    filterValue: tag.filterValue,
  })) ?? [];
};
